import React from 'react';
import {
  GridActionsCellItem,
  GridColumns,
  GridRowParams,
} from '@mui/x-data-grid';
import { AdminDashboardTable } from './AdminDashboardTable';
import { CompanyAdminMeta, Office } from '@dispatch/shared/types';
import { actionsColumn, clickToCopy, textColumn } from '@dispatch/web/ui';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { handleModalOpen, onClick } from './helpers';

export const OfficeAdmin = ({
  offices = [],
  modalState,
  isLoading,
}: {
  offices?: Office[];
  modalState?: {
    meta: CompanyAdminMeta;
    setmeta: React.Dispatch<CompanyAdminMeta>;
  };
  isLoading?: boolean;
}) => {
  const handleClick = React.useCallback(
    (params: GridRowParams) => onClick('addOffice', params, modalState),
    [modalState?.meta.addOffice]
  );

  const handleDelete = React.useCallback(
    (params: GridRowParams & { type?: string }) => {
      params.type = 'office';
      onClick('delete', params, modalState);
    },
    [modalState?.meta]
  );

  const columns: GridColumns = [
    clickToCopy({
      field: 'integrationGUID',
      headerName: 'ID',
      flex: 2,
    }),
    textColumn({
      field: 'name',
      headerName: 'Name',
      flex: 2,
    }),
    actionsColumn((params: GridRowParams) => [
      <GridActionsCellItem
        icon={<EditIcon />}
        label="EDIT"
        onClick={() => {
          handleClick(params);
        }}
        showInMenu
      />,
      <GridActionsCellItem
        icon={<DeleteIcon />}
        label="DELETE"
        onClick={() => {
          handleDelete(params);
        }}
        showInMenu
      />,
    ]),
  ];

  return (
    <AdminDashboardTable<Office>
      isLoading={isLoading}
      columns={columns}
      data={offices}
      type="office"
      identifier="integrationGUID"
      handleClick={() => handleModalOpen('addOffice', modalState)}
    />
  );
};
